export let state = {
	user_name: "",
	number: "",
	users: [],
	loading: true,
	error: ""
};

export default state;
